import { FormattedMessage, MessageDescriptor } from 'react-intl';
import { SvgIcon } from '@mui/material';
import AccountBalanceWalletOutlined from '@mui/icons-material/AccountBalanceWalletOutlined';
import TimelapseOutlined from '@mui/icons-material/TimelapseOutlined';
import NotificationsActiveOutlined from '@mui/icons-material/NotificationsActiveOutlined';
import ReceiptLongOutlined from '@mui/icons-material/ReceiptLongOutlined';
import LocalMallOutlined from '@mui/icons-material/LocalMallOutlined';
import LocalGasStationOutlined from '@mui/icons-material/LocalGasStationOutlined';

import { AppRoutePath } from '@ocx-app/pages/AppRoutePath';

import { List, ListItemText, ListItemStartIcon, ListItemNavLink, Paper } from '@ocx/ui';

import { profileMessages } from '../profile.messages';

export type LoyaltyDetailsListProps = {
  isWalletEnabled: boolean;
  isPointExpirationEnabled: boolean;
  isCommunicationPreferencesEnabled: boolean;
  isProductInterestsEnabled: boolean;
  isPreferredFuelGradeEnabled: boolean;
};

type LoyaltyDetailsFeatureFlagKey = keyof LoyaltyDetailsListProps;
type LoyaltyDetailsMenuItem = {
  Icon: typeof SvgIcon;
  title: MessageDescriptor;
  path: AppRoutePath;
  featureFlagName?: LoyaltyDetailsFeatureFlagKey;
};

const items: LoyaltyDetailsMenuItem[] = [
  {
    featureFlagName: 'isCommunicationPreferencesEnabled',
    path: AppRoutePath.CommunicationPreferences,
    Icon: NotificationsActiveOutlined,
    title: profileMessages['profile:communicationPreference'],
  },
  {
    featureFlagName: 'isProductInterestsEnabled',
    path: AppRoutePath.ProductInterests,
    Icon: LocalMallOutlined,
    title: profileMessages['profile:productInterests'],
  },
  {
    path: AppRoutePath.TransactionHistory,
    Icon: ReceiptLongOutlined,
    title: profileMessages['profile:receiptsButtonTitle'],
  },
  {
    featureFlagName: 'isWalletEnabled',
    path: AppRoutePath.Wallet,
    Icon: AccountBalanceWalletOutlined,
    title: profileMessages['profile:walletButtonTitle'],
  },
  {
    featureFlagName: 'isPointExpirationEnabled',
    path: AppRoutePath.PointExpiration,
    Icon: TimelapseOutlined,
    title: profileMessages['profile:pointExpirationButtonTitle'],
  },
  {
    featureFlagName: 'isPreferredFuelGradeEnabled',
    path: AppRoutePath.PreferredFuelGrade,
    Icon: LocalGasStationOutlined,
    title: profileMessages['profile:preferredFuelGradeButtonTitle'],
  },
];

export const LoyaltyDetailsList = (props: LoyaltyDetailsListProps) => {
  return (
    <Paper p={0} sx={{ overflow: 'hidden' }}>
      <List>
        {items
          .filter((item) => (item.featureFlagName ? props[item.featureFlagName] : true))
          .map(({ Icon, title, path }) => {
            return (
              <ListItemNavLink key={path} to={path}>
                <ListItemStartIcon>
                  <Icon />
                </ListItemStartIcon>
                <ListItemText>
                  <FormattedMessage {...title} />
                </ListItemText>
              </ListItemNavLink>
            );
          })}
      </List>
    </Paper>
  );
};
